import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface CoinBadgeProps {
  amount: number;
  size?: 'sm' | 'md' | 'lg';
  animate?: boolean;
  className?: string;
}

export function CoinBadge({ amount, size = 'md', animate = false, className }: CoinBadgeProps) {
  const sizeClasses = {
    sm: 'text-sm px-2 py-1',
    md: 'text-base px-3 py-1.5',
    lg: 'text-xl px-4 py-2',
  };

  return (
    <motion.div
      className={cn('coin-badge font-mono', sizeClasses[size], className)}
      initial={animate ? { scale: 0.8, opacity: 0 } : undefined}
      animate={animate ? { scale: 1, opacity: 1 } : undefined}
      transition={{ duration: 0.3, type: 'spring' }}
    >
      <span className="text-lg">🪙</span>
      <span className="font-bold">{amount.toLocaleString()}</span>
    </motion.div>
  );
}
